export default class Coa3Actions {

    static NEW_DATA = 'NEW_DATA';
    static UPDATE_DATA='UPDATE_DATA';
    static SHOW_DATA='SHOW_DATA';
    static VIEW_DATA='VIEW_DATA';
    static DELETE_DATA='DELETE_DATA';
    static ON_SUBMIT='ON_SUBMIT';
    static ERROR_DATA='ERROR_DATA';
    static PROCESS_DATA='PROCESS_DATA';
    static RESET_DATA='RESET_DATA';
    static SUCCESS_DATA='SUCCESS_DATA';
    static ERROR_SERVER='ERROR_SERVER';
    static GET_HELPER_COA3 ='GET_HELPER_COA3';
    static RESET_LIST ='RESET_LIST';

    static submit(){
      return {
        type: Coa3Actions.ON_SUBMIT
      };
    }
  
    static create(data) {
      return {
        type: Coa3Actions.NEW_DATA,
        payload: data
      };
    }
  
    static update(data) {
      return {
        type: Coa3Actions.UPDATE_DATA,
        payload: data
      };
    }
  
    static view(data) {
      return {
        type: Coa3Actions.VIEW_DATA,
        payload: data
      };
    }
  
    static delete(data) {
      return {
        type: Coa3Actions.DELETE_DATA
      };
    }
  
    static list(data) {
      return {
        type: Coa3Actions.SHOW_DATA,
        payload: data
      };
    }
    static error(error){
      return {
        type: Coa3Actions.ERROR_DATA,
        payload: error
      };
    }
    static success(){
      return {
        type: Coa3Actions.SUCCESS_DATA,
      };
    }
    static process(){
      return {
        type: Coa3Actions.PROCESS_DATA,
      };
    }
    static reset(){
      return {
        type: Coa3Actions.RESET_DATA,
      };
    }
    static resetList(){
      return {
        type: Coa3Actions.RESET_LIST,
      };
    }
  static getHelper(data){
    return{
      type : Coa3Actions.GET_HELPER_COA3,
      payload : data
    };

  }
    static errorInternal(error){
      return {
        type: Coa3Actions.ERROR_SERVER,
        payload: error
      };
    }
  }